import { render, staticRenderFns } from "./FangYuanGLEdit.vue?vue&type=template&id=1d0b3e35&scoped=true"
import script from "./FangYuanGLEdit.vue?vue&type=script&lang=js"
export * from "./FangYuanGLEdit.vue?vue&type=script&lang=js"
import style0 from "./FangYuanGLEdit.vue?vue&type=style&index=0&id=1d0b3e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0b3e35",
  null
  
)

export default component.exports